import script from "./OrgCredentialsPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./OrgCredentialsPanel.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__